import { render, staticRenderFns } from "./yuanup.vue?vue&type=template&id=2fb5e128&scoped=true&"
import script from "./yuanup.vue?vue&type=script&lang=js&"
export * from "./yuanup.vue?vue&type=script&lang=js&"
import style0 from "./yuanup.vue?vue&type=style&index=0&id=2fb5e128&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb5e128",
  null
  
)

export default component.exports